/* @flow */

import { takeEvery, all } from 'redux-saga/effects';
import { workerRequest } from '../diplomatico/workers';

/**
 * Worker to handle the request of Intelligences
 */
export const workerRequestIntelligencesOptions = {
  requestParams: {
    endpoint: '/intelligences',
    method: 'get'
  }
};

export const workerRequestIntelligences = workerRequest(workerRequestIntelligencesOptions);

export function* watchIntelligencesRequest(): any {
  yield all([
    takeEvery('REQUEST_INTELLIGENCES', workerRequestIntelligences)
  ]);
}
